import React, {Component} from 'react';
import Calendar from "react-calendar";
import {
    getAvailableTimes,
    getSubZones,
    getZones,
    scheduleInstallation
} from "../state-management/actions/scheduler/SchedulerActions";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import moment from "moment";
import {ToastContainer} from "react-toastify";
import {getStates} from "../state-management/actions/states/StatesActions";
import 'react-toastify/dist/ReactToastify.css'

class Scheduler extends Component {

    constructor(props) {
        super(props);

        this.state = {

            address: '',
            zone: '',
            subzone: '',
            date: new Date(),
            reference: this.props.match.params.reference,
            available: '',
            time: ''

        }

    }

    onChange = e => this.setState({

        [e.target.name]: e.target.value

    });

    componentDidMount() {

        this.props.getZones();
        this.props.getStates()

    }

    static propTypes = {

        getZones: PropTypes.func.isRequired,
        zones: PropTypes.object.isRequired,
        getSubZones: PropTypes.func.isRequired,
        getAvailableTimes: PropTypes.func.isRequired,
        scheduleInstallation: PropTypes.func.isRequired

    };

    subZoneChange = e => {

        this.setState({

            subzone: e.target.value

        });

        const {date} = this.state;
        if (e.target.value && date) {

            const data = {

                date: moment(this.state.date).format("YYYY-MM-DD"),
                sub_zone_id: e.target.value

            };

            this.props.getAvailableTimes(data);

        } else {

        }
    };

    onDateChange = date => {

        this.setState({

            date

        });

        const {subzone} = this.state;

        if (subzone && date) {

            const data = {

                date: moment(this.state.date).format("YYYY-MM-DD"),
                sub_zone_id: subzone

            };

            this.props.getAvailableTimes(data);

        } else {

        }

    };

    getSubZone = e => {

        if (e.target.value) {

           this.props.getSubZones(e.target.value);

        }

    };

    componentWillReceiveProps(nextProps, nextContext) {

        if(nextProps.status === "SUCCESS"){
            this.setState({

                address: '',
                zone: '',
                subzone: '',
                date: new Date(),
                reference: '',
                available: '',
                time: ''

            })

        }

    }

    createSchedule = e => {

        e.preventDefault();

        const {appState} = this.props.location;
        // const {ref} = this.props.location.appState.reference;
        const { address, state, date, reference, available} = this.state;

        const data = {

            address: appState ? appState.data.address : address,
            state,
            date: moment(date).format("YYYY-MM-DD"),
            payment_reference: appState ? appState.reference : reference,
            user_id: appState ? appState.userid : null,
            zone_id: document.getElementById('zoneId').value,
            category_id: appState ? appState.category : null,
            sub_zone_id: document.getElementById('subzoneId').value,
            available_zone_time_id: available

        };

        this.props.scheduleInstallation(data);

    };

    render() {

        const {appState} = this.props.location;
        const {zones, subzones, available, loading, states, loadTime} = this.props;
        console.log(states)
        const {date, reference, state, address} = this.state;

        return (
            <div className="main-wrapper mt-5">
                <div className="col-md-7 m-auto col-sm-12">
                    <h4 className="text-center">
                        Schedule Appointment
                    </h4>
                    <div className="d-flex flex-row">
                        <div className="col-12">
                            <form className="form-horizontal" onSubmit={this.createSchedule}>

                                <div className="col-md-12 mb-3 d-flex p-0">

                                    <div className="col-lg-6 text-left">
                                        <label className="copy-font-new m-0 p-0">Zone</label>
                                        <select className="form-control"
                                                onChange={this.getSubZone}
                                                onClick={this.getSubZone}
                                                id="zoneId"
                                                required
                                                name="zone">
                                            <option value="">Select Zone</option>
                                            { zones ? zones.map(zone => {
                                                    return <option value={zone.id} key={zone.id} id={zone.id}>{zone.name.toUpperCase()}</option>
                                                }
                                            ) : null}
                                        </select>
                                    </div>

                                </div>

                                <div className="form-group">

                                    <div className="text-left col-lg-6">
                                        <label className="copy-font-new m-0 p-0"> Select Date </label>
                                        <div className="container mb-3 p-0">
                                            <Calendar onChange={this.onDateChange}
                                                      value={date}/>
                                        </div>
                                    </div>

                                </div>

                                <div className="form-group">
                                    {appState ?
                                        <div className="col-md-12 mb-3 d-flex p-0">
                                            <div className="col-lg-6 text-left">
                                                <label className="copy-font-new m-0 p-0">Reference</label>
                                                <input type="text"
                                                       name="address"
                                                       className="form-control"
                                                       placeholder="Address"
                                                       value={appState.reference}
                                                       onChange={this.onChange}
                                                       readOnly/>
                                            </div>

                                        </div> :
                                        <div className="col-md-12 mb-3 d-flex p-0">
                                            <div className="col-lg-6 text-left">
                                                <label className="copy-font-new m-0 p-0">Reference</label>
                                                <input type="text"
                                                       name="reference"
                                                       className="form-control"
                                                       placeholder="Reference"
                                                       value={reference}
                                                       onChange={this.onChange}/>
                                            </div>

                                        </div> }

                                </div>


                                <div className="form-group">
                                    {appState ?
                                        <div className="col-md-12 mb-3 d-flex p-0">
                                            <div className="col-lg-6 text-left">
                                                <label className="copy-font-new m-0 p-0">Address</label>
                                                <input type="text"
                                                       name="address"
                                                       className="form-control"
                                                       placeholder="Address"
                                                       value={appState.data.address}
                                                       readOnly
                                                       onChange={this.onChange}/>
                                            </div>

                                        </div> :
                                        <div className="col-md-12 mb-3 d-flex p-0">
                                            <div className="col-lg-6 text-left">
                                                <label className="copy-font-new m-0 p-0">Address</label>
                                                <input type="text"
                                                       name="address"
                                                       className="form-control"
                                                       placeholder="Address"
                                                       value={address}
                                                       onChange={this.onChange}/>
                                            </div>

                                        </div> }

                                        <div className="form-group">
                                            <div className="col-lg-6 text-left">

                                                {subzones.length ? <div className="col-lg-6 text-left">
                                                    <label className="copy-font-new m-0 p-0">Sub zone</label>
                                                    <select className="form-control"
                                                            onChange={this.subZoneChange}
                                                            id="subzoneId"
                                                            required
                                                            name="subzone">
                                                        <option value="">Select Subzone</option>
                                                        {subzones ? subzones.map(subzone =>{
                                                            return <option value={subzone.id} key={subzone.id} id={subzone.id}>{subzone.name.toUpperCase()}</option>
                                                        }) : null}
                                                    </select>
                                                </div>  : null}

                                            </div>
                                        </div>

                                    <div className="col-md-12 mb-3 d-flex p-0">
                                        <div className="col-lg-6 text-left">
                                            <label className="copy-font-new m-0 p-0">State</label>
                                            <select className="form-control"
                                                    value={state}
                                                    onChange={this.onChange}
                                                    name="state">
                                                { states ? states.map(state => {
                                                        return <option value={state.Name} key={state.Name}>{state.Name.toUpperCase()}</option>
                                                    }
                                                ) : null}
                                            </select>
                                        </div>
                                    </div>

                                    <div className="col-md-12 mb-3 d-flex p-0">

                                        {available.length ? <div className="col-lg-6 text-left">
                                            <label className="copy-font-new m-0 p-0">Select Available Time</label>
                                            <select name="available"
                                                    className="form-control"
                                                    id="timeId"
                                                    onChange={this.onChange}
                                                    required>

                                                {loadTime ?
                                                    <small>loading</small> :
                                                    available.map(av => {
                                                        return <option value={av.id} key={av.id}>{av.time}</option>
                                                    })}

                                            </select>
                                        </div> : null}

                                    </div>
                                </div>

                                {loading ? <div className="direction text-center">
                                    <button className="btn btn-green2" disabled={true}>Submitting...</button>
                                </div> : <div className="direction text-center">
                                    <button className="btn btn-green2">Submit</button>
                                </div>}
                            </form>
                            <ToastContainer/>

                        </div>


                    </div>


                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({

    zones: state.scheduler.zones,
    subzones: state.scheduler.subzones,
    available: state.scheduler.times,
    loadSub: state.scheduler.loadSub,
    loading: state.scheduler.loadSchedule,
    status: state.scheduler.message,
    states: state.states.states,
    loadTime: state.scheduler.loadTime

});

export default connect(mapStateToProps, {getZones, getSubZones, getAvailableTimes, scheduleInstallation, getStates})(Scheduler);